// chatSummary.js - ONE small poller shared by the pop-up alert (ChatAlerts) and the Sidebar badge.
// Asks the server every 5 s how many chats are waiting for a person (every 15 s while this tab is in the background).
import axiosInstance from './axiosInstance';

const EVERY_MS = 5000;
let tick = 0;
const listeners = new Set();
let state = { waiting: 0, unread: 0, waiting_chats: [] };
let timer = null;
let shopId = null;
let visibilityBound = false;

async function load() {
  try {
    const res = await axiosInstance.get('/feedback/chats/summary/', { params: shopId ? { shop_id: shopId } : {} });
    if (res?.data && typeof res.data === 'object') {
      state = { waiting: 0, unread: 0, waiting_chats: [], ...res.data };
      listeners.forEach((fn) => fn(state));
    }
  } catch {
    /* no access to chats / offline - stay quiet */
  }
}

export const getChatSummary = () => state;

export const subscribeChatSummary = (fn) => {
  listeners.add(fn);
  fn(state);
  return () => listeners.delete(fn);
};

export const refreshChatSummary = () => load();

export function startChatSummary(shop) {
  const next = shop ? String(shop) : null;
  const changed = next !== shopId;
  shopId = next;
  if (timer) {
    if (changed) load();
    return;
  }
  load();
  timer = setInterval(() => {
    tick += 1;
    if (!document.hidden || tick % 3 === 0) load(); // background tab: only every 3rd round
  }, EVERY_MS);
  if (!visibilityBound) {
    visibilityBound = true;
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && timer) load();
    });
  }
}

export function stopChatSummary() {
  if (timer) clearInterval(timer);
  timer = null;
}